import { render, staticRenderFns } from "./interviewRecordItem.vue?vue&type=template&id=cf843558&scoped=true"
import script from "./interviewRecordItem.vue?vue&type=script&lang=js"
export * from "./interviewRecordItem.vue?vue&type=script&lang=js"
import style0 from "./interviewRecordItem.vue?vue&type=style&index=0&id=cf843558&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf843558",
  null
  
)

export default component.exports